module.exports = __webpack_public_path__ + "img/avatar1.85918afd.png";